import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/axelerate-logo-white.svg'
import _imports_1 from '@/assets/icons/flags/mxn.png'
import _imports_2 from '@/assets/icons/flags/usd.png'
import _imports_3 from '@/assets/icons/chevron-down-white.svg'
import _imports_4 from '@/assets/icons/settings.svg'
import _imports_5 from '@/assets/product_symbol.svg'
import _imports_6 from '@/assets/icons/logout.svg'
import _imports_7 from '@/assets/workforce.svg'
import _imports_8 from '@/assets/navbar-icons/home-selected.svg'
import _imports_9 from '@/assets/navbar-icons/home.svg'
import _imports_10 from '@/assets/navbar-icons/payroll-selected.svg'
import _imports_11 from '@/assets/navbar-icons/payroll.svg'
import _imports_12 from '@/assets/navbar-icons/users-selected.svg'
import _imports_13 from '@/assets/navbar-icons/users.svg'
import _imports_14 from '@/assets/navbar-icons/reimbursement-selected.svg'
import _imports_15 from '@/assets/navbar-icons/reimbursement.svg'


const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-white bg-primary py-4" }
const _hoisted_3 = { class: "container flex flex-row justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-6"
  })
], -1)
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-6 w-6"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-6 w-6"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "=", -1)
const _hoisted_10 = {
  key: 0,
  class: "z-40 mt-8 top-0 text-black absolute bg-white rounded shadow border border-primary p-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-px h-full bg-white mx-6" }, null, -1)
const _hoisted_12 = { class: "relative flex" }
const _hoisted_13 = { class: "flex flex-row items-center" }
const _hoisted_14 = { class: "flex flex-row items-center" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "uppercase" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-px h-full bg-white mx-2" }, null, -1)
const _hoisted_18 = { class: "flex flex-row self-end items-center" }
const _hoisted_19 = { class: "pr-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_21 = {
  key: 0,
  ref: "currencyDropdown",
  class: "absolute flex flex-col text-black bg-white left-0 rounded-2xl shadow mt-8 -ml-6 p-2 w-42 z-50"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex flex-row" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "uppercase" }
const _hoisted_26 = {
  key: 1,
  ref: "dropdown",
  class: "absolute flex flex-col text-black bg-white right-0 rounded-2xl shadow p-4 mt-8 w-96 z-50"
}
const _hoisted_27 = { class: "flex flex-col mt-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
    /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Account settings")
  ]),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-4 w-4 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" })
  ])
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "h-0.5 bg-gray-200 mx-4 my-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-5 w-5",
    src: _imports_5
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Change to Talent Sourcing")
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-200 mx-4 my-2" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Log out")
], -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "container" }
const _hoisted_37 = { class: "flex flex-row items-center justify-between py-4" }
const _hoisted_38 = { class: "flex flex-row" }
const _hoisted_39 = { class: "flex flex-row items-center" }
const _hoisted_40 = {
  key: 0,
  class: "relative inline-block text-left text-black",
  ref: "modalPlatform"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "pl-5 text-sm font-bold" }, "Workforce Solutions", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "pl-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 9l-7 7-7-7"
    })
  ])
], -1)
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = {
  key: 0,
  class: "origin-top-right absolute right-0 w-64 rounded-2xl shadow-2xl text-sm overflow-hidden z-20"
}
const _hoisted_46 = {
  class: "rounded-md bg-white px-2 py-2",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "p-4 flex items-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start items-start text-white mr-6" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          class: "mr-6"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col -ml-7 py-1" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold mt-1" }, "Talent Sourcing")
      ])
    ])
  ])
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "mr-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-5 font-bold text-sm" }, "Workforce Solutions")
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "flex flex-row text-sm pl-16" }
const _hoisted_52 = {
  key: 0,
  src: _imports_8,
  class: "mx-auto"
}
const _hoisted_53 = {
  key: 1,
  src: _imports_9,
  class: "mx-auto"
}
const _hoisted_54 = {
  key: 0,
  src: _imports_10,
  class: "mx-auto"
}
const _hoisted_55 = {
  key: 1,
  src: _imports_11,
  class: "mx-auto"
}
const _hoisted_56 = {
  key: 2,
  class: "font-bold ml-4 text-black"
}
const _hoisted_57 = {
  key: 3,
  class: "font-bold ml-4 text-gray-400"
}
const _hoisted_58 = {
  key: 0,
  src: _imports_12,
  class: "mx-auto"
}
const _hoisted_59 = {
  key: 1,
  src: _imports_13,
  class: "mx-auto"
}
const _hoisted_60 = {
  key: 2,
  class: "font-bold ml-4 text-black"
}
const _hoisted_61 = {
  key: 3,
  class: "font-bold ml-4 text-gray-400"
}
const _hoisted_62 = {
  key: 0,
  src: _imports_14,
  class: "mx-auto"
}
const _hoisted_63 = {
  key: 1,
  src: _imports_15,
  class: "mx-auto"
}
const _hoisted_64 = {
  key: 2,
  class: "font-bold ml-4 text-black"
}
const _hoisted_65 = {
  key: 3,
  class: "font-bold ml-4 text-gray-400"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_ModalAddPayment = _resolveComponent("ModalAddPayment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "relative flex flex-row items-center",
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false))
          }, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.exchangeRate), 1),
            (_ctx.showTooltip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 30-day rolling average "))
              : _createCommentVNode("", true),
            _hoisted_11
          ], 32),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currencyModal = true)),
                class: "mr-4 h-full"
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: require(`@/assets/icons/flags/${_ctx.currency}.png`),
                    class: "w-6 h-6 mr-2"
                  }, null, 8, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, "- $" + _toDisplayString(_ctx.currency), 1)
                ])
              ]),
              _hoisted_17,
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modal = true)),
                class: "mx-4"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.userFirstName + " " + _ctx.userLastName), 1),
                  _hoisted_20
                ])
              ])
            ]),
            (_ctx.currencyModal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (curr, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: i,
                      onClick: ($event: any) => (_ctx.changeCurrency(curr)),
                      class: "hover:bg-background p-4 rounded"
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("img", {
                          src: require(`@/assets/icons/flags/${curr}.png`),
                          class: "w-6 h-6 mr-2"
                        }, null, 8, _hoisted_24),
                        _createElementVNode("span", _hoisted_25, "- $" + _toDisplayString(curr), 1)
                      ])
                    ], 8, _hoisted_22))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true),
            (_ctx.modal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_UserCard, {
                    firstName: _ctx.userFirstName,
                    lastName: _ctx.userLastName,
                    position: _ctx.email,
                    class: "ml-4"
                  }, null, 8, ["firstName", "lastName", "position"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToSettings && _ctx.goToSettings(...args))),
                      class: "rounded p-4 hover:bg-background font-semibold"
                    }, _hoisted_29),
                    (_ctx.roles.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                      : _createCommentVNode("", true),
                    (_ctx.roles.length > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changePlatform && _ctx.changePlatform(...args))),
                          class: "rounded p-4 hover:bg-background"
                        }, _hoisted_32))
                      : _createCommentVNode("", true),
                    _hoisted_33,
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args))),
                      class: "rounded p-4 hover:bg-background"
                    }, _hoisted_35)
                  ])
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            (_ctx.roles.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "flex flex-row items-center",
                      id: "options-menu",
                      "aria-haspopup": "true",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen))
                    }, _hoisted_44),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition ease-out duration-100",
                      "enter-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMenuOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", {
                                  class: "cursor-pointer",
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changePlatform && _ctx.changePlatform(...args)))
                                }, _hoisted_48)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ], 512))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "cursor-pointer",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/')))
                }, _hoisted_50)),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/'))),
                class: _normalizeClass(["flex flex-row items-center hover:bg-gray-100 h-12 rounded py-2 px-4 mr-2", { 'bg-gray-100': _ctx.$route.name === 'Home' }])
              }, [
                (_ctx.$route.name === 'Home')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_52))
                  : (_openBlock(), _createElementBlock("img", _hoisted_53)),
                _createElementVNode("span", {
                  class: _normalizeClass(["font-bold ml-4", { 'text-gray-400': _ctx.$route.name !== 'Home' }])
                }, "Home", 2)
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/payroll'))),
                class: _normalizeClass(["flex flex-row items-center hover:bg-gray-100 h-12 rounded py-2 px-4 mr-2", {
                  'bg-gray-100': _ctx.$route.name === 'Payroll' || _ctx.$route.name === 'Payrolls',
                }])
              }, [
                (_ctx.$route.name === 'Payroll' || _ctx.$route.name === 'Payrolls')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_54))
                  : (_openBlock(), _createElementBlock("img", _hoisted_55)),
                (_ctx.$route.name === 'Payroll' || _ctx.$route.name === 'Payrolls')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_56, " Payroll "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_57, " Payroll "))
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/talent'))),
                class: _normalizeClass(["flex flex-row items-center hover:bg-gray-100 h-12 rounded py-2 px-4 mr-2", {
                  'bg-gray-100': _ctx.$route.name === 'Talents' || _ctx.$route.name === 'Talent',
                }])
              }, [
                (_ctx.$route.name === 'Talent' || _ctx.$route.name === 'Talents')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_58))
                  : (_openBlock(), _createElementBlock("img", _hoisted_59)),
                (_ctx.$route.name === 'Talent' || _ctx.$route.name === 'Talents')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_60, " Talent "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_61, " Talent "))
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/reimbursements'))),
                class: _normalizeClass(["flex flex-row items-center hover:bg-gray-100 h-12 rounded py-2 px-4 mr-2", { 'bg-gray-100': _ctx.$route.name === 'Reimbursements' }])
              }, [
                (_ctx.$route.name === 'Reimbursements')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_62))
                  : (_openBlock(), _createElementBlock("img", _hoisted_63)),
                (_ctx.$route.name === 'Reimbursements')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, " Reimbursements "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_65, " Reimbursements "))
              ], 2)
            ])
          ])
        ]),
        _hoisted_66
      ])
    ]),
    _createVNode(_component_ModalAddPayment, {
      openModal: _ctx.paywall,
      "onUpdate:openModal": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.paywall) = $event))
    }, null, 8, ["openModal"])
  ]))
}